import React, { useState, useEffect } from 'react';
import AdditionalFilters from './additional-filters';
import ApplyFilters from './apply-filters';
import ClearFilters from './clear-filters';
import FilterByCheckbox from './filter-by-checkbox';
import FilterByText from './filter-by-text';
import SelectedFilter from './selected-filter';
import styles from './filters.module.css';
import useFilter from './hooks/useFilter';

const Filters = ({
    className,
    isFilterOpen,
    setSubmissionData,
    submissionsDataCache,
    submissionSummary,
    collectionID,
    setPagingState
}) => {
    const [search, setSearch] = useState(
        sessionStorage.getItem('search') && sessionStorage.getItem('collectionID') === collectionID
            ? JSON.parse(sessionStorage.getItem('search'))
            : {}
    );

    const [selectedStaffGroup, setSelectedStaffGroup] = useState(null);
    const [selectedPCNStaffGroup, setSelectedPCNStaffGroup] = useState(null);
    const [staffRoleOptions, setStaffRoleOptions] = useState([]);
    const [PCNstaffRoleOptions, setPCNStaffRoleOptions] = useState([]);

    useEffect(() => {
        if (Object.keys(search).length === 0) {
            setSubmissionData(submissionsDataCache);
        }
    }, [search, setSubmissionData, submissionsDataCache]);

    useFilter(search, setSubmissionData, submissionsDataCache, collectionID);
    if (!isFilterOpen) {
        return null;
    }

    return (
        <div className={className}>
            <div className={`${styles.filtersHeader} nhsuk-u-padding-3`}>
                <p className="nhsuk-u-font-weight-bold nhsuk-u-margin-bottom-0">Filter</p>
            </div>
            <div className={`${styles.filtersSelected} nhsuk-u-padding-3`}>
                <h4 className="nhsuk-heading-s">Selected filters</h4>
                <div className={styles.filtersClearFilter}>
                    <ClearFilters
                        setSearch={setSearch}
                        setSubmissionData={setSubmissionData}
                        submissionsDataCache={submissionsDataCache}
                        setPagingState={setPagingState}
                    />
                </div>
                <div className="nhsuk-u-margin-top-2">
                    <SelectedFilter
                        search={search}
                        clearSearch={setSearch}
                        submissionSummary={submissionSummary}
                        setPagingState={setPagingState}
                        setSearch={setSearch}
                        submissionsDataCache={submissionsDataCache}
                    />
                </div>
            </div>
            <div className={`${styles.filters} nhsuk-u-padding-3`}>
                <ApplyFilters
                    setSearch={setSearch}
                    search={search}
                    submissionSummary={submissionSummary}
                    setSelectedStaffGroup={setSelectedStaffGroup}
                    setSelectedPCNStaffGroup={setSelectedPCNStaffGroup}
                />
                <FilterByText submissionSummary={submissionSummary} />
                <FilterByCheckbox
                    submissionSummary={submissionSummary}
                    selectedStaffGroup={selectedStaffGroup}
                    setSelectedStaffGroup={setSelectedStaffGroup}
                    staffRoleOptions={staffRoleOptions}
                    setStaffRoleOptions={setStaffRoleOptions}
                    selectedPCNStaffGroup={selectedPCNStaffGroup}
                    setSelectedPCNStaffGroup={setSelectedPCNStaffGroup}
                    PCNstaffRoleOptions={PCNstaffRoleOptions}
                    setPCNStaffRoleOptions={setPCNStaffRoleOptions}
                />
                <AdditionalFilters submissionSummary={submissionSummary} />
            </div>
        </div>
    );
};

export default Filters;
